import { WithStyles, withStyles } from '@mui/styles';
import { AccountRecord } from '@tassat/fred-definitions';

import { FirmAccountWallets } from './firmAccountWallets';
import { muiStyles } from './styles';

export interface FirmAccountWalletsProps extends WithStyles<typeof muiStyles> {
    account: AccountRecord;
}

export default withStyles(muiStyles)(FirmAccountWallets);